export default __webpack_public_path__ + "static/media/business-11.e2a2b934.jpg";